/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { SupportCenterService } from '../../../services/support/support-center.service';
import { ToastService } from '../../../modules/shared/services/toast-message.service';
import * as actions from './support-center.actions';

@Injectable()
export class SupportCenterEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly service: SupportCenterService,
    private router: Router,
    private readonly toastService: ToastService,
  ) {}

  getSupportCenter$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getSupportCenter),
      mergeMap((action) =>
        this.service
          .getSupport(
            action.status,
            action.pageNumber,
            action.pageSize,
            action.searchTerm,
            action.sortBy,
            action.sortDescending,
          )
          .pipe(
            map((supportCenter) => {
              return actions.getSupportCenterSuccess({ supportCenter });
            }),
            catchError((error: any) =>
              of(actions.getSupportCenterFailure(error)),
            ),
          ),
      ),
    ),
  );

  createSupportCase$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.createSupportCase),
      mergeMap((action) =>
        this.service.createSupportCase(action.body).pipe(
          map((response: any) => {
            this.toastService.success(
              response?.message ?? 'Support case created.',
            );
            return actions.createSupportCaseSuccess({
              message: response?.message ?? '',
            });
          }),
          catchError((error: any) =>
            of(actions.createSupportCaseFailure(error)),
          ),
        ),
      ),
    ),
  );

  getCaseById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getCaseById),
      mergeMap((action) =>
        this.service.getCaseById(action.id).pipe(
          map((caseById) => {
            return actions.getCaseByIdSuccess({ caseById });
          }),
          catchError((error: any) => of(actions.getCaseByIdFailure(error))),
        ),
      ),
    ),
  );

  replyToCase$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.replyToCase),
      mergeMap((action) =>
        this.service.replyToCase(action.ticketId, action.message).pipe(
          map(() => actions.getCaseById({ id: action.ticketId })),
          catchError((error) => of(actions.replyToCaseFailure(error))),
        ),
      ),
    ),
  );

  closeCase$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.closeCase),
      mergeMap((action) =>
        this.service.closeCase(action.id).pipe(
          map(() => {
            return actions.getSupportCenter({});
          }),
          catchError((error: any) => of(actions.closeCaseFailure(error))),
        ),
      ),
    ),
  );
}
